import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import FieldIcon from "../../fields3/generic/icon/icon"
import FieldConfig from "../../fields3/proto/field-config"
import {TASK_ICON_CATEGORIES} from "../../gd/const/item-icon/task-categories"
import {IconType} from "../../gd-components/selector/icon-selector/@const"
import {ResourceType} from "./@const"


const baseConfig: FieldConfig[] = [
    {
        fieldId : 'name',
        type    : FieldType.STRING,
        label   : 'Name',
    },
    {
        fieldId             : 'type',
        type                : FieldType.DROPDOWN,
        label               : 'Resource Type',
        showMenuMore        : false,
        addNoValueOption    : false,
        options             : [
            {value: ResourceType.PEOPLE,  label: 'People'},
            {value: ResourceType.ASSETS,  label: 'Assets'},
            {value: ResourceType.GENERIC, label: 'Generic'},
        ],
    },
    {
        fieldId     : 'icon',
        type        : FieldType.ICON,
        label       : 'Icon',
        fieldParams : {
            iconTypes       : [IconType.ITEM_ICONS, IconType.EMOJI_ICONS],
            iconCategories  : TASK_ICON_CATEGORIES,
        },
    },
    {
        fieldId             : 'color',
        type                : FieldType.COLOR,
        label               : 'Color',
        addNoValueOption    : false,
    },
    {
        fieldId : 'skills',
        type    : FieldType.COMPANY_USER_SKILLS,
        label   : 'Skills',
    },
    {
        fieldId : 'notes',
        type    : FieldType.TEXT,
        label   : 'Notes',
    },
    {
        fieldId : 'financeInternalCost',
        type    : FieldType.NUMBER,
        label   : 'Internal cost',
    },
    {
        fieldId : 'financeExternalCost',
        type    : FieldType.NUMBER,
        label   : 'Service rate',
    },
]


export default class ResourceFields extends FieldsCollection {

    get name(): FieldString                { return this.get('name') as FieldString }
    get type(): any                        { return this.get('type') }
    get icon(): FieldIcon                  { return this.get('icon') as FieldIcon }
    get color(): any                       { return this.get('color') }
    get skills(): any                      { return this.get('skills') }
    get notes(): FieldString               { return this.get('notes') as FieldString }
    get financeInternalCost(): any         { return this.get('financeInternalCost') }
    get financeExternalCost(): any         { return this.get('financeExternalCost') }

    constructor() {
        super(baseConfig, EntityType.RESOURCE)
    }
}
